import FeatureCardList from '../modules/feature-card-list'
import FeaturedContentHub from '../modules/content-hub'
import FeaturedProductBlock from "../modules/product-block"
import TwoColBlock from '../modules/two-col-block'
import React, { Component, memo } from "react"
import DisclosureBlock from '../modules/disclosure-block'
import RateAccordionList from '../modules/rate-accordion-list'
import InfoAccordion from '../modules/info-accordion-list'
import StepGuide from '../modules/step-guide'
import ListingHomeLoan from '../listings/listing-home-loan'
import ListingProductGroups from '../listings/listing-product-groups'
import ListingFeaturedProduct from '../listings/listing-featured-product'
import AccordionModule from './../modules/accordion-module';
import RichTextBlock from '../modules/rich-text-block'
import ToggleCardList from '../campaign/toggle-card-list';
import IconCardList from '../modules/icon-card-list'
import FormModule from '../modules/form-module'
import TabModule from '../modules/tab-module'
import FullPageIframe from '../modules/full-page-frame'


interface PageBodyProps {
  components: any[];
}

const PageBody = memo(({ components }: PageBodyProps) => {

  let bodyHTML: JSX.Element[] = [];
  
  for (let section = 0; section < components.length; section++) {
    const component = components[section];
    let bodyMarkup;
    if (component !== null) {
      let typename = component.__typename || component.id?.split("-")[0];

      if (!typename && "stickyNavId" in component) {
        typename = "DatoCMS_StickyNavSectionRecord";
      }

      switch (typename) {
        case 'DatoCMS_ProductFeatureBlockRecord':
          bodyMarkup = (
            <FeaturedProductBlock
              key={section}
              align={component.align}
              auxtitle={component.auxtitle}
              title={component.title}
              subtitle={component.subtitle}
              smartLink={component.smartLink}
              linkText={component.linkText}
              productLinkList={component.productLinkList}
              cardSize={component.cardSize}
              alignment={component.alignment}
            />
          )
          break;
        case 'DatoCMS_FeatureCardListRecord':

          bodyMarkup = (
            <FeatureCardList
              key={section}
              mode={component.mode}
              cardSize={component.cardSize}
              auxtitle={component.auxtitle}
              title={component.title}
              subtitle={component.subtitle}
              smartLink={component.smartLink}
              linkText={component.linkText}
              hideTitle={component.hideTitle}
              featureCardList={component.featureCardList}
            />
          )
          break;
        case 'DatoCMS_FeaturedContentHubRecord':
          bodyMarkup = (
            <FeaturedContentHub
              key={section}
              auxtitle={component.auxtitle}
              title={component.title}
              subtitle={component.subtitle}
              smartLink={component.smartLink}
              linkText={component.linkText}
              articleLinkList={component.articleLinkList}
            />
          )
          break;
        case 'DatoCMS_TwoColBlockRecord':
          bodyMarkup = (
            <TwoColBlock
              key={section}
              auxtitle={component.auxtitle}
              title={component.title}
              subtitle={component.subtitle}
              smartLink={component.smartLink}
              linkText={component.linkText}
              align={component.align}
              image={component.image}
            />
          )
          break;
        case 'DatoCMS_DisclosureBlockRecord':
          bodyMarkup = (
            <DisclosureBlock
              key={section}
              auxtitle={component.auxtitle}
              title={component.title}
              subtitle={component.subtitle}
              resourceHeading={component.resourceHeading}
              resourceList={component.resourceList}
            />
          )
          break;
        case 'DatoCMS_StickyNavSectionRecord':
          bodyMarkup = (
            <a className={`sticky-nav-wedge`} id={component.stickyNavId} key={section} data-datocms-noindex></a>
          )
          break;
        case 'DatoCMS_StepGuideRecord':
          bodyMarkup = (
            <StepGuide
              key={section}
              auxtitle={component.auxtitle}
              title={component.title}
              subtitle={component.subtitle}
              image={component.image}
              steps={component.steps}
            />
          )
          break;
        case 'DatoCMS_ListingHomeLoanRecord':
          bodyMarkup = (
            <ListingHomeLoan
              key={section}
              auxtitle={component.auxtitle}
              title={component.title}
              subtitle={component.information}
              information={component.information}
              defaultLoanAmount={component.defaultLoanAmount}
              minLoanAmount={component.minLoanAmount}
              maxLoanAmount={component.maxLoanAmount}
              productCard={component.productCard}
              hideCalculationOnVariants={component.hideCalculationOnVariants}
            />
          )
          break;
        case 'DatoCMS_ListingProductGroupRecord':
          bodyMarkup = (
            <ListingProductGroups
              key={section}
              data={component}
            />
          )
          break;
        case 'DatoCMS_ListingFeaturedProductRecord':
          bodyMarkup = (
            <ListingFeaturedProduct
              key={section}
              auxtitle={component.auxtitle}
              title={component.title}
              subtitle={component.information}
              information={component.information}
              productCard={component.productCard}
              filterTitle={component.filterTitle}
              preselectedFilter={component.preselectedFilter}
              filters={component.filters}
            />
          )
          break;
        case 'DatoCMS_RatesAccordionListRecord':
          bodyMarkup = (
            <RateAccordionList
              key={section}
              auxtitle={component.auxtitle}
              title={component.title}
              subtitle={component.subtitle}
              disclosure={component.disclosure}
              resourceHeading={component.resourceHeading}
              resourceList={component.resourceList}
              accordionId={component.id}
              accordionList={component.accordionList}
              expandAccordion={component.expandAccordion}
              removeAccordion={component.removeAccordion}
            />
          )
          break;
        case 'DatoCMS_AccordionModuleRecord':
          bodyMarkup = (
            <AccordionModule
              key={section}
              data={component}
            />
          )
          break;
        case 'DatoCMS_RichTextBlockRecord':
          bodyMarkup = (
            <RichTextBlock
              key={section}
              data={component}
            />
          )
          break;
        case 'DatoCMS_InfoAccordionListRecord':
          bodyMarkup = (
            <InfoAccordion
              key={section}
              auxtitle={component.auxtitle}
              title={component.title}
              subtitle={component.subtitle}
              accordionId={component.id}
              accordionList={component.accordionList}
            />
          )
          break;
        case 'DatoCMS_ToggleCardListRecord':
          bodyMarkup = (
            <ToggleCardList
              key={section}
              data={component}
            />
          )
          break;
        case 'DatoCMS_IconCardListRecord':
          bodyMarkup = (
            <IconCardList
              key={section}
              data={component}
            />
          )
          break;
        case 'DatoCMS_FormRecord':
          bodyMarkup = (
            <FormModule key={section} formData={component} />
          )
          break;
        case "DatoCMS_TabModuleRecord":
          bodyMarkup = (<TabModule componentData={component} />)
          break;
        case "DatoCMS_ContentFullPageIframeRecord":
          bodyMarkup = (<FullPageIframe componentData={component} />)
          break;
        default:
          break;
      }
      bodyHTML.push(bodyMarkup)
    }
  }
  return <>{bodyHTML}</>;
})

export default PageBody;
